import { useEffect, useState } from "react";
import { Card, CardHeader, CardContent } from "src/@/components/ui/card";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { RowInput } from "src/components/forms/RowInput";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import AutomationOnlyExecute from "../components/AutomationOnlyExecute";
import { actionListaCaixasEntrada } from "src/actions/chamados/actionChamadosConfig";

const tipoOptions = [
    { value: "interno", label: "Interno" },
    { value: "externo", label: "Externo" },
];

const CardChamadoGeneric = ({
    actionPhase,
    actionState,
    changeActionState,
    users,
    user
}) => {
    const [caixasEntrada, setCaixasEntrada] = useState([]);

    useEffect(() => {
        async function fetchCaixasEntrada() {
            try {
                const response = await actionListaCaixasEntrada(`?cliente_id=${user?.clienteId}`);
                if (response.data?.data) {
                    setCaixasEntrada(response.data.data);
                }
            } catch (error) {
                console.error("Erro ao buscar caixas de entrada:", error);
            }
        }
        if (user?.clienteId && actionState?.chamadoTipo === "externo") {
            fetchCaixasEntrada();
        }
    }, [user?.clienteId, actionState?.chamadoTipo]);

    const caixasFormatted = caixasEntrada.map((c) => ({
        value: c._id,
        label: c.nome || c.titulo || c._id,
    }));

    return (
        <Card className="w-full">
            <CardHeader>
                <LabelFromAction>
                    {actionPhase.name}
                </LabelFromAction>
            </CardHeader>
            <CardContent>
                <div className="flex flex-col gap-4">
                    <RowInput
                        label="Tipo de chamado"
                        info="Filtrar por tipo de chamado (opcional)"
                        input={
                            <Select
                                value={actionState?.chamadoTipo || ""}
                                onValueChange={(value) =>
                                    changeActionState({ name: "chamadoTipo", value: value || null })
                                }
                            >
                                <SelectTrigger>
                                    <SelectValue placeholder="Todos os tipos" />
                                </SelectTrigger>
                                <SelectContent>
                                    {tipoOptions.map((opt) => (
                                        <SelectItem key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        }
                    />
                    {actionState?.chamadoTipo === "externo" && (
                        <RowInput
                            label="Caixa de entrada"
                            info="Filtrar por caixa de entrada específica (opcional)"
                            input={
                                <Select
                                    value={actionState?.chamadoCaixaEntradaId || ""}
                                    onValueChange={(value) =>
                                        changeActionState({ name: "chamadoCaixaEntradaId", value: value || null })
                                    }
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder="Todas as caixas de entrada" />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {caixasFormatted.map((opt) => (
                                            <SelectItem key={opt.value} value={opt.value}>
                                                {opt.label}
                                            </SelectItem>
                                        ))}
                                    </SelectContent>
                                </Select>
                            }
                        />
                    )}
                    <RowInput
                        label="Usuário responsável"
                        info="Filtrar por usuário direcionado no chamado"
                        input={
                            <MultiSelect
                                options={users}
                                onValueChange={(e) =>
                                    changeActionState({ name: "chamadoUsersAssign", value: e })
                                }
                                defaultValue={actionState?.chamadoUsersAssign}
                                placeholder="Selecionar usuários (opcional)"
                                variant="inverted"
                                animation={2}
                                maxCount={3}
                            />
                        }
                    />
                    <AutomationOnlyExecute
                        actionState={actionState}
                        changeActionState={changeActionState}
                    />
                </div>
            </CardContent>
        </Card>
    );
};

export default CardChamadoGeneric;
